import { H as h, u as i, Ze as t, b as c } from "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
import { q as u } from "./chart-base.helpers-WE8Q3BCJ-BQ-7yhqE.js";
import { r as m } from "./data-item-base-BmOJu1LN-BCN8_qJP.js";
import { t as p } from "./beacon-primitive-ChVMWFlW-Df2Js5lw.js";
const l = {
  beaconTagName: "beacon-chart-tooltip-data"
}, g = h`.container{align-items:baseline;display:flex}.container.main{border-block-end:var(--beacon-chart-tooltip-override-divider-border-block-end, none);padding-block-end:var(--beacon-chart-tooltip-override-container-main-padding-block-end, 0)}.container.subset{margin-block-start:var(--beacon-chart-tooltip-override-container-subset-margin-block-start, 0)}.icon{align-items:center;display:grid;justify-content:start;margin-inline-end:var(--beacon-unit-subatomic);min-inline-size:var(--beacon-unit-base)}.icon ::slotted(svg),.icon .fallback-icon{fill:var(--icon-color, currentColor)}.label,.metric{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default))}.label{padding-block-start:var(--beacon-chart-tooltip-override-label-padding-block-start, 0)}.metric{font-weight:var(--beacon-font-weight-bold);margin-inline-start:var(--beacon-unit-atomic);padding-block-start:var(--beacon-chart-tooltip-override-metric-padding-block-start, 0)}:host([subset]) .icon{padding-inline-start:3px}:host([subset]) .icon ::slotted(svg),:host([subset]) .icon .fallback-icon{inline-size:var(--beacon-unit-subatomic)}`;
var f = Object.defineProperty, d = (o, n, r, y) => {
  for (var e = void 0, a = o.length - 1, s; a >= 0; a--)
    (s = o[a]) && (e = s(n, r, e) || e);
  return e && f(n, r, e), e;
};
const b = class extends p(m) {
  constructor() {
    super(...arguments), this.beaconTagName = l.beaconTagName, this.disableIcon = !1, this.subset = !1;
  }
  static get styles() {
    return [...super.styles, g];
  }
  /** The hierarchy level of the data item. */
  get dataLevel() {
    return this.subset ? "subset" : "main";
  }
  /** The appropriate color for the icon depending on hierarchy. */
  get iconColor() {
    return this.subset ? "var(--beacon-chart-tooltip-divider-color-background)" : this.color ? this.color : `var(--beacon-chart-override-drilldown-series-color-${this.index}, var(--beacon-chart-series-color-${this.index}))`;
  }
  /** Conditionally render icon HTML. */
  renderIcon() {
    return this.disableIcon ? i : t`<div class="icon">
          <slot name="icon">${u(this.index % 5)}</slot>
        </div>`;
  }
  /** Conditionally render label HTML. */
  renderLabel() {
    return this.label ? t`<div class="label">${this.label}</div>` : i;
  }
  /** Conditionally render value HTML. */
  renderValue() {
    return this.value ? t`<div class="metric">${this.value}</div>` : i;
  }
  render() {
    return t`<style>
        ::slotted(svg),
        .fallback-icon {
          --icon-color: ${this.iconColor};
        }
      </style>

      <div class="container ${this.dataLevel}">${this.renderIcon()} ${this.renderLabel()} ${this.renderValue()}</div>`;
  }
};
b.tagName = l.beaconTagName;
let v = b;
d([
  c({ attribute: "disable-icon", type: Boolean })
], v.prototype, "disableIcon");
d([
  c({ type: Boolean })
], v.prototype, "subset");
export {
  v as BeaconChartTooltipData
};
